import { useId } from 'react';

/**
 * Branded arrow-and-hook icon (gradient red → indigo arrow with right-angle hook).
 * Ported from the Figma export (dev-mcp misc/ArrowIcon). Replaces the generic
 * red-circle arrow used in the Hero feature cards.
 */
export default function ArrowIcon({ className = '' }) {
  const uid = useId().replace(/:/g, 'a');
  return (
    <svg
      width="32"
      height="34"
      viewBox="0 0 32.762 33.3686"
      fill="none"
      className={`shrink-0 ${className}`}
      aria-hidden="true"
    >
      {/* Arrow shaft + head */}
      <path
        d="M32.504 7.11061C32.848 6.76655 32.848 6.20874 32.504 5.86468L26.8973 0.258039C26.5533 -0.0860128 25.9954 -0.0860128 25.6514 0.258039C25.3073 0.60209 25.3073 1.15991 25.6514 1.50396L30.6351 6.48764L25.6514 11.4713C25.3073 11.8154 25.3073 12.3732 25.6514 12.7173C25.9954 13.0613 26.5533 13.0613 26.8973 12.7173L32.504 7.11061ZM13.881 6.48764V7.36864L31.881 7.36864V6.48764V5.60665L13.881 5.60665V6.48764Z"
        fill={`url(#ag-${uid})`}
      />
      {/* Corner hook */}
      <path
        d="M13.881 7.3685H5.28627C3.24267 7.46778 1.76186 9.0075 1.76186 10.8929V19.4876H0V10.8929C0 7.97354 2.3669 5.60679 5.28627 5.60679H13.881V7.3685Z"
        fill="#E85E57"
      />
      {/* Vertical stem */}
      <path
        d="M0.881 15.4876L0.881 32.4876"
        stroke="#E45D59"
        strokeLinecap="round"
        strokeWidth="1.762"
      />
      <defs>
        <linearGradient
          id={`ag-${uid}`}
          gradientUnits="userSpaceOnUse"
          x1="13.881"
          x2="29.7927"
          y1="6.48764"
          y2="12.7737"
        >
          <stop stopColor="#E45D59" />
          <stop offset="1" stopColor="#5964A0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
